import React from 'react';
import {NavLink} from 'react-router-dom';

function NavbarItem({ to, text }) {
  return (
    <div className="navitem">
      <NavLink
        to={to}
        style={({ isActive }) => isActive ? {color: 'goldenrod'} : undefined}
      >
        {text}
      </NavLink>
    </div>
  );
}

export default NavbarItem;
